import { createRequest, RequestConfig } from 'app/common/api';

import { TTicketOrdersConstraints } from '../core/tickets-orders-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_ticket_orders',
};

export const getTicketOrdersRequest = (
  constraints?: TTicketOrdersConstraints
) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
